import React from "react";
import useTranslation from "next-translate/useTranslation";

export default function Textarea({
  name,
  label,
  labelDisplay,
  placeholder,
  register,
  errors,
  required = false,
}) {
  const { t } = useTranslation("common");

  return (
    <div>
      <label
        htmlFor={name}
        className={
          labelDisplay === "invisible"
            ? "sr-only"
            : "inline-block mb-1 font-important font-medium uppercase text-sm"
        }
      >
        {label}
        {required && (
          <>
            {" "}
            <span className="text-primary">*</span>
          </>
        )}
      </label>
      <textarea
        id={name}
        rows="5"
        className="w-full border p-4 placeholder:text-gray-300 border-opacity-50 outline-none focus:border-primary rounded"
        placeholder={placeholder}
        {...register(name, {
          required: required ? t("form.required") : false,
        })}
      />
      {errors && (
        <p role="alert" className="text-sm text-red-500 mb-2 font-semibold">
          {errors.message}
        </p>
      )}
    </div>
  );
}
